import React, { memo, useCallback, useRef, useState } from 'react'

import { AppHeaderWrapper, ExtraCss } from './style'
import HeaderLeft from './cpns/HeaderLeft'
import HeaderCenter from './cpns/HeaderCenter'
import HeaderRight from './cpns/HeaderRight'
import { shallowEqual, useSelector } from 'react-redux'
import classNames from 'classnames'
import useScrollPosition from '@/hooks/useScrollPosition'
import { ThemeProvider } from 'styled-components'

const AppHeader = memo((props) => {
  // 属性
  const [isSearch, setIsSearch] = useState(false)
  const { headerConfig } = useSelector(
    (state) => ({
      headerConfig: state.main.headerConfig
    }),
    shallowEqual
  )
  const { isFixed, topAlpha } = headerConfig

  /* 切换正常搜索、激活状态的搜索栏 */
  const changeIsSearch = useCallback(
    (flag) => {
      setIsSearch(flag)
    },
    [setIsSearch]
  )

  /* 页面滚动一定距离后，激活状态关闭 */
  const { scrollY } = useScrollPosition()
  let prevY = useRef(0)
  if (!isSearch) prevY.current = scrollY
  if (isSearch && Math.abs(scrollY - prevY.current) > 30) setIsSearch(false)

  /* home页顶部透明效果 */
  // 条件：
  const isAlpha = topAlpha && scrollY === 0
  console.log('topAlpha', topAlpha)
  console.log('scrollY', scrollY)
  console.log('isAlpha', isAlpha)

  return (
    <ThemeProvider theme={{isAlpha}}>
      <AppHeaderWrapper className={classNames({ fixed: isFixed })}>
        <div className="content">
          <div className="base">
            <HeaderLeft />
            <HeaderCenter isSearch={isAlpha || isSearch} changeIsSearch={changeIsSearch} />
            <HeaderRight />
          </div>
          <ExtraCss isSearch={isSearch}></ExtraCss>
        </div>
        {isSearch && <div className="mask" onClick={(e) => setIsSearch(false)}></div>}
      </AppHeaderWrapper>
    </ThemeProvider>
  )
})

export default AppHeader
